import Link from '@mui/material/Link';
import { ReactNode } from 'react';
import DisclosuresDialog from 'src/components/DisclosuresDialog';
import useDialog from 'src/helpers/hooks/useDialog';
import { PaymentFormValues } from 'src/pages/payment-msi/PaymentMsiV2/PaymentMsiV2';

interface DisclosuresButtonProps {
  children: ReactNode;
  email: string;
  paymentType: PaymentFormValues['paymentPlan'];
  monthlyInstallment: string;
  monthlyDownPaymentAmount: string;
  annualAmountPremium: string;
  buildingState: PaymentFormValues['billingAddress']['state'];
}

const disclosuresButtonStyles = {
  link: {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    cursor: 'pointer',
  },
};

export function DisclosuresButton({ children, email }: DisclosuresButtonProps) {
  const {
    handleOpen: openDialog,
    handleClose: closeDialog,
    open: isDialogOpen,
  } = useDialog();

  return (
    <>
      <Link
        sx={disclosuresButtonStyles.link}
        role="button"
        component={'span'}
        onClick={openDialog}
      >
        {children}
      </Link>
      <DisclosuresDialog
        onClose={closeDialog}
        open={isDialogOpen}
        email={email}
      />
    </>
  );
}
